import React from 'react';

import {
  FaBox,
  FaDollyFlatbed,
  FaMoneyBillWave,
  FaListAlt,
  FaFolder,
  FaBoxOpen,
  FaCalendarAlt,
} from 'react-icons/fa';

import { RiHandCoinLine } from 'react-icons/ri';

export default {
  Displays: {
    icon: <FaBox size={32} />,
    link: '/projects/displays',
  },
  Materiais: {
    icon: <FaDollyFlatbed size={32} />,
    link: '/projects/materials',
  },
  Pagamentos: {
    icon: <FaMoneyBillWave size={32} />,
    link: '/projects/sponsorships',
  },
  'Reportar um Problema': {
    icon: <FaListAlt size={32} />,
    link: '/projects/adversities',
  },
  Pastas: {
    icon: <FaFolder size={32} />,
    link: '/projects/folders',
  },
  Amostras: {
    icon: <FaBoxOpen size={32} />,
    link: '/projects/samples',
  },
  Eventos: {
    icon: <FaCalendarAlt size={32} />,
    link: '/projects/events',
  },
  Rebate: {
    icon: <RiHandCoinLine size={32} />,
    link: '/projects/rebate',
  },
};
